import React, { FC } from "react";
import styles from "../../../styles/B2C/ProgressBar.module.scss";

interface ProgressBarProps {
  currentStep: number;
  totalSteps: number;
}

const ProgressBar: FC<ProgressBarProps> = ({ currentStep, totalSteps }) => {
  const progress = (currentStep / totalSteps) * 100;

  return (
    <div
      className={styles.progressFill}
      style={{ width: `${progress}%` }}
    />
  );
};

export default ProgressBar;
